import { FilterFilled } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Collapse, CollapseProps, Space } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { IconColor } from '../icon/IconColor';

const StyledCollapse = styled(Collapse)`
  &.ant-collapse {
    > .ant-collapse-item {
      > .ant-collapse-header {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        font-weight: 600;
      }
      > .ant-collapse-content > .ant-collapse-content-box {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
        /* background-color: ${props => props.theme.colorBgContainer}; */
      }
    }
  }
`;

export interface TableSearchCollapseProps
  extends Omit<CollapseProps, 'children' | 'items' | 'activeKey'> {
  /** Parte sinistra per il form */
  children?: React.ReactNode;
  /** Pulsanti posizionati a destra della card */
  button?: React.ReactNode;
  /** Indica che la ricerca è attiva */
  filtered?: boolean;
}

/**
 * Card con collapse per mostrare i form di ricerca nelle pagine elenco
 *
 *
 */
export function TableSearchCollapse(props: TableSearchCollapseProps) {
  const { button, children, filtered, ...otherProps } = props;
  const { t } = useTranslation();

  return (
    <StyledCollapse
      ghost
      defaultActiveKey={['filters']}
      {...otherProps}
      items={[
        {
          label: (
            <Space size={6}>
              <span>
                {t('collapse.filtri-di-ricerca', 'Filtri di Ricerca')}
              </span>
              <IconColor type={filtered ? 'primary' : 'tertiary'}>
                <FilterFilled />
              </IconColor>
            </Space>
          ),
          key: 'filters',
          children: children,
        },
      ]}
    />
  );
}
